import { FunctionComponent, ReactElement } from "react";

import { IReduxEnumType } from "@multiweb/reactCore/enums";

export type EnumProviderComponentChildrenProps = {
    /** Typ enumu, který bude vrácen potomkem v podobě render props. */
    readonly enumType: IReduxEnumType | undefined | null;
};

export type EnumProviderComponentProps = {
    /** Funkce jako potomek, která vrací správný enum. */
    readonly children: (props: EnumProviderComponentChildrenProps) => ReactElement;
} & EnumProviderComponentChildrenProps;

export const EnumProviderComponent: FunctionComponent<EnumProviderComponentProps> = ({
    enumType,
    children,
}) => (
    children({ enumType })
);
